// package: sentimentanalyzer
// file: sentiment-analyzer.proto

var sentiment_analyzer_pb = require("./sentiment-analyzer_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var SentimentAnalyzer = (function () {
  function SentimentAnalyzer() {}
  SentimentAnalyzer.serviceName = "sentimentanalyzer.SentimentAnalyzer";
  return SentimentAnalyzer;
}());

SentimentAnalyzer.GetSymbolsSentiment = {
  methodName: "GetSymbolsSentiment",
  service: SentimentAnalyzer,
  requestStream: false,
  responseStream: false,
  requestType: sentiment_analyzer_pb.GetSymbolsSentimentReq,
  responseType: sentiment_analyzer_pb.GetSymbolsSentimentReply
};

SentimentAnalyzer.GetBrokersSymbolSentiment = {
  methodName: "GetBrokersSymbolSentiment",
  service: SentimentAnalyzer,
  requestStream: false,
  responseStream: false,
  requestType: sentiment_analyzer_pb.GetBrokersSymbolSentimentReq,
  responseType: sentiment_analyzer_pb.GetBrokersSymbolSentimentReply
};

SentimentAnalyzer.SentimentOverview = {
  methodName: "SentimentOverview",
  service: SentimentAnalyzer,
  requestStream: false,
  responseStream: false,
  requestType: sentiment_analyzer_pb.SentimentOverviewReq,
  responseType: sentiment_analyzer_pb.SentimentOverviewReply
};

SentimentAnalyzer.GetSymbols = {
  methodName: "GetSymbols",
  service: SentimentAnalyzer,
  requestStream: false,
  responseStream: false,
  requestType: sentiment_analyzer_pb.GetSymbolsReq,
  responseType: sentiment_analyzer_pb.GetSymbolsReply
};

exports.SentimentAnalyzer = SentimentAnalyzer;

function SentimentAnalyzerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

SentimentAnalyzerClient.prototype.getSymbolsSentiment = function getSymbolsSentiment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SentimentAnalyzer.GetSymbolsSentiment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SentimentAnalyzerClient.prototype.getBrokersSymbolSentiment = function getBrokersSymbolSentiment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SentimentAnalyzer.GetBrokersSymbolSentiment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SentimentAnalyzerClient.prototype.sentimentOverview = function sentimentOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SentimentAnalyzer.SentimentOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SentimentAnalyzerClient.prototype.getSymbols = function getSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SentimentAnalyzer.GetSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.SentimentAnalyzerClient = SentimentAnalyzerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "sentimentanalyzer.Internal";
  return Internal;
}());

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

exports.InternalClient = InternalClient;

